import { NgModule } from '@angular/core';
import {
    ActiveUserPipe,
    PersonPipe,
    FormControlPipe,
    FullNamePipe,
    UserDetailPipe,
    UserPhotoPipe,
    ToMetricPipe,
    ToImperialPipe,
    BoolConversion,
    DoubleConversion,
    DoubleSPMConversion,

} from './common.pipe';

@NgModule({
    imports: [],
    declarations: [
        ActiveUserPipe,
        PersonPipe,
        FormControlPipe,
        FullNamePipe,
        UserDetailPipe,
        UserPhotoPipe,
        ToMetricPipe,
        ToImperialPipe,
        BoolConversion,
        DoubleConversion,
        DoubleSPMConversion,
    ],
    exports: [
        ActiveUserPipe,
        PersonPipe,
        FormControlPipe,
        FullNamePipe,
        UserDetailPipe,
        UserPhotoPipe,
        ToMetricPipe,
        ToImperialPipe,
        BoolConversion,
        DoubleConversion,
        DoubleSPMConversion,
    ],
    providers: [
    ]

})
export class PipesModule { }
